import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n'
import './index.css'
import {
    RecoilRoot,
    atom,
    selector,
    useRecoilState,
    useRecoilValue,
} from 'recoil';
import {themeOptions} from "./Theme/ThemeOptions";
import {ThemeProvider} from "@mui/material";

ReactDOM.render(
    <RecoilRoot>
        <ThemeProvider theme={themeOptions}>
            <App/>
        </ThemeProvider>
    </RecoilRoot>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
